<template>
  <header>
    <div class="close-slide-up-container">
      <button class="link" @click="$emit('close-share')">
        <ns-icon icon-name="icon-close" class="close-slide-up" />
      </button>
    </div>
    <h2>{{ faqTitle }}</h2>
  </header>
</template>

<script>
import config from '../js/qualificationsConfigService'
import { NsIcon } from '@nuskin/ns-icon'

export default {
  components: {
    NsIcon,
  },
  data() {
    return {
      tdc: config.getTdc(),
    }
  },
  methods: {},
  mounted() {},
  name: 'FaqHeader',
  props: {
    faqTitle: String,
  },
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

$blackhole: map.get(colors.$baseColors, "blackhole");
$shells: map.get(colors.$baseColors, "shells");
header {
  .close-slide-up-container {
    margin-bottom: 15px;
  }

  .slide-up .slide-up-content .close-slide-up-container {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
}
</style>
